export const sectionSlider = {
    data: () => ({
        selected: 0,
    }),

    computed: {
        currentSlide() {
            return this.items[this.selected] || {}
        },
        readableIndex() {
            const prefixValue = (num) => num > 9 ? `0${num}` : `00${num}`
            return `${prefixValue(this.selected + 1)}/${prefixValue(this.items.length)}`
        },
        isPrev() {
            return this.selected > 0
        },
        isNext() {
            return this.selected + 1 < this.items.length
        },
    },

    methods: {
        setActive( i ) {
            this.selected = this.selected === i ? -1 : i
        },
        prev() {
            if ( !this.isPrev ) return;

            this.selected--
        },
        next() {
            if ( !this.isNext ) return;
            
            this.selected++
        },
    },
}